export default __webpack_public_path__ + "static/media/pet bottles.3f6d1899.jpeg";